module.exports = __webpack_public_path__ + "img/download_light_ic.6adacbb3.png";